


































































/* 
  getLog 获取日志管理信息查询分页列表
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import { getLog } from "../../../api/logManage";
//引入导入、导出、下载的处理函数
import importAndExportMixin from "../../../mixins/importAndExport";

@Component({
  name: "logManage",
  mixins: [importAndExportMixin]
})
export default class extends Vue {
  private operationType: string = ""; //操作类型
  private operationTime: string = ""; //操作时间
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseIdArray: string[] = []; //勾选的数据id集合
  created() {
    //获取列表
    this.getData();
  }

  private getRequestParams() {
    return {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      beginTime: this.operationTime && this.operationTime[0], //开始时间
      endTime: this.operationTime && this.operationTime[1], //结束时间
      logOperationType: this.operationType //操作类型
    };
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getLog(this.getRequestParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //“excel导出”处理
  private exportHandle() {
    (this as any).downloadHandle(
      "exportLog",
      "日志信息.xlsx",
      this.getRequestParams()
    );
  }

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
